import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * CPTextingGuard — CON-1699.
 *
 * Route backstop for pages that only make sense on an account texting
 * through CP. Reads the same state.account.user.textingProvider the nav
 * entry reads (NavBar/index.js), so the two agree by construction; the
 * server applies the same test on its side (SetupSnapshotService
 * isCPTexting) and answers 200 with applicable:false rather than 403.
 *
 * This is a backstop, not the gate: the nav entry is what keeps non-CP
 * accounts from arriving here, and the page itself renders the
 * not-applicable answer if the two ever disagree.
 */
function CPTextingGuard({ children }) {
  const textingProvider = useSelector((state) => state?.account?.user?.textingProvider);

  if (textingProvider !== 'CP') {
    return <Redirect to="/app" />;
  }

  return children;
}

CPTextingGuard.propTypes = {
  children: PropTypes.any,
};

export default CPTextingGuard;
